<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="text-h5 text-center font-weight-bold">
          {{ workout.name }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card flat>
          <v-row align="center">
            <v-col cols="2">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="purple"
                    rounded
                    large
                    class="ml-3 white--text"
                    v-bind="attrs"
                    v-on="on"
                    :disabled="interval == 0"
                    @click="decrementInterval()"
                    ><v-icon>mdi-chevron-up</v-icon></v-btn
                  >
                </template>
                <span>Previous</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8">
              <v-window v-model="interval" vertical>
                <v-window-item
                  v-for="(int, index) in workout.intervals"
                  :key="`interval-${index}`"
                >
                  <v-card>
                    <v-card-text>
                      <div class="font-weight-bold text-center">
                        Interval {{ interval + 1 }} of
                        {{ workout.intervals.length }}
                      </div>
                      <div class="text-center">
                        {{ intervalDetails(interval) }}
                      </div>
                      <div v-show="results[interval]" class="text-center">
                        Result: {{ results[interval] }}
                      </div>
                      <div
                        v-if="interval + 1 < workout.intervals.length"
                        class="text-center grey--text text--lighten-1 mt-4"
                      >
                        Up Next: {{ intervalDetails(interval + 1) }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-window-item>
              </v-window>
            </v-col>
            <v-col cols="2">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    rounded
                    large
                    color="purple"
                    class="ml-3 white--text"
                    v-bind="attrs"
                    v-on="on"
                    :disabled="interval == workout.intervals.length"
                    @click="incrementInterval()"
                    ><v-icon>mdi-chevron-down</v-icon></v-btn
                  >
                </template>
                <span>Next</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-switch v-model="autoplay" dense class="ml-5">
          <template v-slot:label>
            Autoplay
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="ml-3"
                  color="purple"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <span
                >The timer will automatically move to the next interval once
                'Save' is pressed, the next interval selected, or the countdown
                expires. The next interval will automatically start.</span
              >
            </v-tooltip>
          </template>
        </v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <Clock
          ref="clock"
          :duration="clockPreset"
          :autostart="autoplay"
          @save="saveClock"
          @complete="clockComplete"
        ></Clock>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Clock from "./Clock";

export default {
  name: "WorkoutFlowControl",
  components: {
    Clock,
  },
  props: {
    workout: {
      type: Object,
      required: true,
    },
    pace: {
      type: Object,
    },
    modality: {
      type: String,
    },
  },
  data: function () {
    return {
      interval: 0,
      results:
        this.workout.intervals && this.workout.intervals.length > 0
          ? Array.from({ length: this.workout.intervals.length })
          : undefined,
      autoplay: false,
    };
  },
  computed: {
    clockPreset: function () {
      if (this.workout.intervals[this.interval].unit == "s") {
        return this.workout.intervals[this.interval].magnitude * 1000;
      } else {
        return undefined;
      }
    },
  },
  methods: {
    saveClock: function (result) {
      this.results.splice(this.interval, 1, result);
      if (this.autoplay) {
        this.incrementInterval();
      }
    },
    clockComplete: function () {
      if (this.autoplay) {
        this.incrementInterval();
      }
    },
    incrementInterval: function () {
      if (this.interval + 1 > this.workout.intervals.length) {
        return this.interval;
      } else {
        return this.interval++;
      }
    },
    decrementInterval: function () {
      if (this.interval - 1 < 0) {
        return this.interval;
      } else {
        return this.interval--;
      }
    },
    intervalDetails: function (interval) {
      var int = this.workout.intervals[interval];

      var result = "";
      if (int.unit == "s") {
        result += this.millisecondsToDisplay(int.magnitude * 1000);
      } else {
        result += int.magnitude + int.unit;
      }

      if (int.unit == "r" && int.movement) {
        result += " " + int.movement;
      }
      result += " @ " + int.intensity + " pace";

      console.log(result);
      return result;
    },
    millisecondsToDisplay: function (time) {
      // Pad to 2 or 3 digits, default is 2
      function pad(n, z) {
        z = z || 2;
        return ("00" + n).slice(-z);
      }

      var ms = time % 1000;
      time = (time - ms) / 1000;
      var secs = time % 60;
      time = (time - secs) / 60;
      var mins = time % 60;
      var hrs = (time - mins) / 60;

      var result = "";
      if (hrs > 0) {
        result += hrs + ":" + pad(mins) + ":" + pad(secs);
      } else if (mins > 0) {
        result += mins + ":" + pad(secs);
      } else {
        result += secs;
      }

      return result;
    },
  },
  watch: {
    interval: function () {
      this.$refs.clock.resetClock();
    },
  },
};
</script>

<style scoped>
#stage-indicator {
  height: 400px;
}
</style>
